// --- Order Queries ---

const orderItemFields = `
  itemId
  quantity
  unitPrice
  discountPerUnit
  discountAmount
  lineTotal
  variationName
  detail {
    productItemId
    productName
    variationName
    unit
  }
`;

const orderFields = `
  orderId
  orderNumber
  companyId
  storeId
  status
  subtotalAmount
  discountAmount
  taxAmount
  totalAmount
  customerId
  items {
${orderItemFields}
  }
  createdAt
  updatedAt
  reservationExpiresAt
  updatedBy
`;

export const listOrdersQuery = `
  query ListOrders($input: ListOrdersInput) {
    listOrders(input: $input) {
      code
      totalCount
      totalPages
      page
      pageSize
      orders {
${orderFields}
      }
    }
  }
`;

export const listOrdersByStoreQuery = `
  query ListOrdersByStore($input: ListOrdersInput) {
    listOrdersByStore(input: $input) {
      code
      totalCount
      totalPages
      page
      pageSize
      orders {
${orderFields}
      }
    }
  }
`;

export const getOrderQuery = `
  query GetOrder($orderId: String!) {
    getOrder(orderId: $orderId) {
      code
      order {
${orderFields}
      }
    }
  }
`;

export const getOrderByPayloadQuery = `
  query GetOrderByPayload($input: GetOrderInput!) {
    getOrderByPayload(input: $input) {
      code
      order {
${orderFields}
      }
    }
  }
`;

// --- Order Mutations ---

export const createOrderMutation = `
  mutation CreateOrder($input: CreateOrderInput!) {
    createOrder(input: $input) {
      code
      order {
${orderFields}
      }
    }
  }
`;

// Returns GetOrderResponse → { code, order }
export const addOrderItemMutation = `
  mutation AddOrderItem($input: AddOrderItemInput!) {
    addOrderItem(input: $input) {
      code
      order {
${orderFields}
      }
    }
  }
`;

// Returns GetOrderResponse → { code, order }
export const updateOrderItemMutation = `
  mutation UpdateOrderItem($input: UpdateOrderItemInput!) {
    updateOrderItem(input: $input) {
      code
      order {
${orderFields}
      }
    }
  }
`;

// Returns GetOrderResponse → { code, order }
export const updateOrderItemDiscountMutation = `
  mutation UpdateOrderItemDiscount($input: UpdateOrderItemDiscountInput!) {
    updateOrderItemDiscount(input: $input) {
      code
      order {
${orderFields}
      }
    }
  }
`;

// Returns GetOrderResponse → { code, order }
export const removeOrderItemMutation = `
  mutation RemoveOrderItem($input: RemoveOrderItemInput!) {
    removeOrderItem(input: $input) {
      code
      order {
${orderFields}
      }
    }
  }
`;

export const scanOrderItemMutation = `
  mutation ScanOrderItem($input: ScanOrderItemInput!) {
    scanOrderItem(input: $input) {
      code
      scan {
        type
        sellingMode
        orderLine {
          orderLineId
          productName
          variationName
          quantity
          unitPrice
          subtotal
          productItemId
        }
        subtotalAmount
        taxAmount
        totalAmount
        productItemId
        productName
        variationName
        unit
        remainingQuantity
        measureType
      }
    }
  }
`;

export const confirmOrderItemMutation = `
  mutation ConfirmOrderItem($input: ConfirmOrderItemInput!) {
    confirmOrderItem(input: $input) {
      code
      scan {
        type
        sellingMode
        orderLine {
          orderLineId
          productName
          variationName
          quantity
          unitPrice
          subtotal
          productItemId
        }
        subtotalAmount
        taxAmount
        totalAmount
        productItemId
        productName
        variationName
        unit
        remainingQuantity
        measureType
      }
    }
  }
`;

export const cancelOrderMutation = `
  mutation CancelOrder($input: CancelOrderInput!) {
    cancelOrder(input: $input) {
      code
      order {
${orderFields}
      }
    }
  }
`;

export const acceptOfferMutation = `
  mutation AcceptOffer($input: AcceptOfferInput!) {
    acceptOffer(input: $input) {
      code
      order {
${orderFields}
      }
    }
  }
`;

/** Sales order status changes (e.g. DRAFT → OFFER_ACCEPTED via `updateOrderStatus`). */
export const updateOrderStatusMutation = `
  mutation UpdateSalesOrderStatus($input: UpdateOrderStatusInput!) {
    updateOrderStatus(input: $input) {
      code
      order {
${orderFields}
      }
    }
  }
`;

export const completeOrderMutation = `
  mutation CompleteOrder($input: CompleteOrderInput!) {
    completeOrder(input: $input) {
      code
      order {
${orderFields}
      }
    }
  }
`;

export const updateOrderCustomerMutation = `
  mutation UpdateOrderCustomer($input: UpdateOrderCustomerInput!) {
    updateOrderCustomer(input: $input) {
      code
      order {
${orderFields}
      }
    }
  }
`;
